module.exports = __webpack_public_path__ + "img/mail.5a8172f8.svg";